export type LanguageCode = 'sv-SE' | 'en-US';
export const DEFAULT_LOCALE = 'sv-SE';

export enum TranslationKey {
  uiButtonNext = 'ui.ButtonNext',
  uiButtonBack = 'ui.ButtonBack',
  uiButtonGoBack = 'ui.ButtonGoBack',
  uiStartTitle = 'ui.StartTitle',
  uiBeginLegimitize = 'ui.BeginLegimitize',
  uiSpecify = 'ui.Specify',
  uiSpecifyCountry = 'ui.SpecifyCountry',
  uiPersonalIdNumber = 'ui.PersonalIdNumber',
  uiBankIdTitle = 'ui.BankIdTitle',
  uiSubmit = 'ui.Apply',
  uiEdit = 'ui.Edit',
  uiName = 'ui.Name',
  uiCancel = 'ui.Cancel',
  uiLogin = 'ui.Login',
  uiTryAgain = 'ui.TryAgain',
  uiClickHere = 'ui.ClickHere',
  uiErrorTitle = 'ui.ErrorTitle',
  uiPersonalInformation = 'ui.PersonalInformation',
  uiPowerOfAttorney = 'ui.PowerOfAttorney',
  uiMonths = 'ui.Months',
  errorRequired = 'error.Required',
  errorInvalidEmail = 'error.InvalidEmail',
  errorOneOfPayments = 'error.OneOfPayments',
  errorChooseAssociation = 'error.ChooseAssociation',
  errorFillInRequiredFields = 'error.FillInRequiredFields',
  errorInvalidPersonalID = 'error.InvalidPersonalID',
  errorExactNumberOfNumbers = 'error.ExactNumberOfChars',
  errorTooLong = 'error.tooLong',
  errorTooShort = 'error.tooShort',
  errorSubmissionError = 'error.SubmissionError',
  errorInvalidBankAccount = 'error.InvalidBankAccount',
  errorConsentRequired = 'error.ConsentRequired',
  errorBankIDTimeout = 'error.BankIDTimeout',
  errorAcceptCondtions = 'error.AcceptConditions',
  errorMismatch = 'error.Mismatch',
  errorOneOf = 'error.OneOf',
  formFirstName = 'form.FirstName',
  formFamilyName = 'form.FamilyName',
  formName = 'form.Name',
  formFullName = 'form.FullName',
  formPersonalIdentityNumber = 'form.PersonalIdentityNumber',
  formStreetName = 'form.StreetName',
  formPostalCode = 'form.PostalCode',
  formCity = 'form.City',
  formCountry = 'form.Country',
  formEmailAddress = 'form.EmailAddress',
  formPhoneNumber = 'form.PhoneNumber',
  formStreetAddress = 'form.StreetAddress',
  formFullAddress = 'form.FullAddress',
  formSelectAuthenticationOption = 'form.SelectAuthenticationOption',
  formRepeat = 'form.Repeat',
  formSocialSecurityNumber = 'form.SocialSecurityNumber',
  formMessage = 'form.Message',
  formAttachFile = 'form.AttachFile',
  formTotalAmount = 'form.TotalAmount',
  formNumberOfMonths = 'form.NumberOfMonths',
  formReference = 'form.Reference',
  submissionErrorBadRequest = 'submission.errorBadRequest',
  tradeUnionFormPaymentType1 = 'tradeUnionFormForm.paymentType1',
  tradeUnionFormPaymentType2 = 'tradeUnionFormForm.paymentType2',
  tradeUnionFormReason = 'tradeUnionForm.Reason',
  tradeUnionFormDate = 'tradeUnionForm.Date',
  tradeUnionFormPaymentType = 'tradeUnionForm.paymentType',
  tradeUnionFormSelectPaymentType = 'tradeUnionForm.selectPaymentType',
  tradeUnionFormHeading = 'tradeUnionForm.heading',
  tradeUnionFormError404 = 'tradeUnionForm.error404',
  tradeUnionFormError400 = 'tradeUnionForm.error400',
  tradeUnionFormError401 = 'tradeUnionForm.error401',
  tradeUnionFormError500 = 'tradeUnionForm.error500',
  tradeUnionFormSuccessMessage = 'tradeUnionForm.successMessage',
  tradeUnionFormMemberEmail = 'tradeUnionForm.member.email',
  tradeUnionFormMemberPhone = 'tradeUnionForm.member.phonme',
  cgiAnotherDeviceStep1 = 'cgi.AnotherDeviceStep1',
  cgiAnotherDeviceStep2 = 'cgi.AnotherDeviceStep2',
  cgiAnotherDeviceStep3 = 'cgi.AnotherDeviceStep3',
  cgiBankIdSameDevice = 'cgi.BankIdSameDevice',
  cgiBankIdOtherDevice = 'cgi.BankIdOtherDevice',
  cgiFrejaSameDevice = 'cgi.FrejaSameDevice',
  cgiFrejaOtherDevice = 'cgi.FrejaOtherDevice',
  cgiErrorGeneric = 'cgi.ErrorGeneric',
  cgiMobileInstructions = 'cgi.MobileInstructions',
  cgiAutostartButtonText = 'cgi.AutostartButtonText',
  cgiTitle = 'cgi.Title',
  resumedMemberShipFormTitle = 'resumedMemberShipForm.title',
  resumedMemberShipFormErrorMessage = 'resumedMemberShipForm.errorMessage',
  resumedMembershipFormDirectDebit = 'resumedMembershipForm.directDebit',
  resumedMemberShipFormSign = 'resumedMemberShipForm.sign',
  resumedMemberShipFormBankInput = 'resumedMemberShipForm.bankInput',
  resumedMemberShipFormClearingInput = 'resumedMemberShipForm.clearingInput',
  resumedMemberShipFormAccountInput = 'resumedMemberShipForm.accountInput',
  resumedMemberShipFormDirectDebitConsent = 'resumedMemberShipFormDirectDebit.consent',
  resumedMemberShipFormConsent = 'resumedMemberShipForm.consent',
  resumedMemberShipFormConsentErrorMessage = 'resumedMemberShipForm.consentErrorMessage',
  resumedMemberShipFormSubmit = 'resumedMemberShipForm.submit',
  resumedMemberShipFormCgiSignText = 'resumedMemberShipForm.cgiSignText',
  powerOfAttorneyFormCgiSignText = 'powerOfAttorneyForm.cgiSignText',
  powerOfAttorneyFormTitle = 'powerOfAttorneyForm.title',
  contactFormSubjectInput = 'contactForm.subjectInput',
  contactFormSubjectInputPlaceholder = 'contactForm.subjectInputPlaceholder',
  contactFormTitle = 'contactForm.title',
  contactFormSocialSecurityNumberSubLabel = 'contactForm.socialSecurityNumberSubLabel',
  refundFormTitle = 'refundForm.title',
  refundFormMonthValidationMessage = 'refundForm.monthValidationMessage',
  refundFormAmountValidationMessage = 'refundForm.amountValidationMessage',
  refundFormAmountPlaceholder = 'refundForm.amountPlaceholder',
  refundFormAmountLegend = 'refundForm.amountLegend',
  refundFormPaymentPlanLegend = 'refundForm.paymentPlanLegend',
  refundFormPaymentPlanSublabel = 'refundForm.paymentPlanSublabel',
  refundFormPaymentPlanPlaceholder = 'refundForm.paymentPlanPlaceholder',
  refundFormSuggestionsLabel = 'refundForm.suggestionsLabel',
  refundFormSuggestionsSublabel = 'refundForm.suggestionsSublabel',
  refundFormReferenceSublabel = 'refundForm.referenceSublabel',
  refundFormOtherSuggestions = 'refundForm.otherSuggestions',
}

type String = {
  [index in TranslationKey]: string;
};

type Translation = {
  [index in LanguageCode]: String;
};
export const TranslationStrings: Translation = {
  ['en-US']: {
    [TranslationKey.uiButtonNext]: 'Proceed',
    [TranslationKey.uiButtonBack]: 'Back',
    [TranslationKey.uiButtonGoBack]: 'Go back',
    [TranslationKey.uiStartTitle]: 'We appreciate that you want to join Akademikernas a-kassa',
    [TranslationKey.uiBeginLegimitize]: 'Provide electronic identification to start the process',
    [TranslationKey.uiSpecify]: 'Specify',
    [TranslationKey.uiSpecifyCountry]: 'Specify country',
    [TranslationKey.uiPersonalIdNumber]: 'Personnummer',
    [TranslationKey.uiBankIdTitle]: 'Open BankID',
    [TranslationKey.uiSubmit]: 'Submit case',
    [TranslationKey.uiEdit]: 'Edit',
    [TranslationKey.uiName]: `The member's name`,
    [TranslationKey.uiCancel]: 'Cancel',
    [TranslationKey.uiLogin]: 'Log in',
    [TranslationKey.uiTryAgain]: 'Try again',
    [TranslationKey.uiClickHere]: 'Click here',
    [TranslationKey.uiErrorTitle]: 'Something went wrong',
    [TranslationKey.uiPersonalInformation]: 'Personal information',
    [TranslationKey.uiPowerOfAttorney]: 'Power of attorney',
    [TranslationKey.uiMonths]: 'Months',
    [TranslationKey.errorRequired]: 'This field cannot be left blank',
    [TranslationKey.errorInvalidEmail]: 'Please enter a valid email address',
    [TranslationKey.errorOneOfPayments]: 'You must select a payment choice',
    [TranslationKey.errorChooseAssociation]:
      'Please choose which through which trade union (fackförbund) you would like to pay our membership fee',
    [TranslationKey.errorFillInRequiredFields]: 'Please fill in all required fields',
    [TranslationKey.errorInvalidPersonalID]: 'Please enter a valid personal identity number (personnummer)',
    [TranslationKey.errorExactNumberOfNumbers]: 'It has to be exactly {length} digits',
    [TranslationKey.errorTooLong]: `It can't be longer than {length} characters`,
    [TranslationKey.errorTooShort]: `It can't be shorter than {length} caracters`,
    [TranslationKey.errorSubmissionError]:
      'Something went wrong when trying to submit your application. Please make sure the information is correct and try again.',
    [TranslationKey.errorInvalidBankAccount]:
      'There seems to be a problem with your bank details. Did you enter both your clearing and account numbers?',
    [TranslationKey.errorConsentRequired]: 'You must agree to the terms and conditions in order to submit',
    [TranslationKey.errorBankIDTimeout]: 'The sign in was aborted due to inactivity',
    [TranslationKey.errorAcceptCondtions]: 'You must accept the conditions',
    [TranslationKey.errorMismatch]: 'Make sure the value matches the {otherField} field',
    [TranslationKey.errorOneOf]: 'You must select an option',
    [TranslationKey.formFirstName]: 'First Name',
    [TranslationKey.formFamilyName]: 'Family Name',
    [TranslationKey.formName]: 'Name',
    [TranslationKey.formFullName]: 'First and last name',
    [TranslationKey.formPersonalIdentityNumber]: 'Swedish personal identity number',
    [TranslationKey.formStreetName]: 'Street name and number',
    [TranslationKey.formPostalCode]: 'Postal code (postnummer)',
    [TranslationKey.formCity]: 'City or town',
    [TranslationKey.formCountry]: 'Country',
    [TranslationKey.formEmailAddress]: 'Email address',
    [TranslationKey.formPhoneNumber]: 'Mobile telephone number',
    [TranslationKey.formFullAddress]: 'Street address, postal code and city/town',
    [TranslationKey.formStreetAddress]: 'Street address',
    [TranslationKey.formRepeat]: 'Repeat {fieldName}',
    [TranslationKey.formSocialSecurityNumber]: 'Personnummer',
    [TranslationKey.formSelectAuthenticationOption]: 'Select authentication option',
    [TranslationKey.formMessage]: 'Message',
    [TranslationKey.formAttachFile]: 'Attach file',
    [TranslationKey.formTotalAmount]: 'Total amount',
    [TranslationKey.formNumberOfMonths]: 'Number of months',
    [TranslationKey.formReference]: 'Reference',
    [TranslationKey.submissionErrorBadRequest]: 'There is invalid data in the form. Please make sure all fields are filled and try again.',
    [TranslationKey.tradeUnionFormPaymentType1]: 'Betala direkt till a-kassan (direktanslutning)',
    [TranslationKey.tradeUnionFormPaymentType2]: 'Betala till förbund (ta över fakturering)',
    [TranslationKey.tradeUnionFormDate]: 'The change will take place starting',
    [TranslationKey.tradeUnionFormReason]: 'Reason',
    [TranslationKey.tradeUnionFormPaymentType]: 'Payment choice',
    [TranslationKey.tradeUnionFormSelectPaymentType]: 'Select payment choice',
    [TranslationKey.tradeUnionFormHeading]: 'Change of payment method',
    [TranslationKey.tradeUnionFormError400]: 'Invalid input data. Please check the fields and try again',
    [TranslationKey.tradeUnionFormError404]: 'There is no member with the submitted personnummer',
    [TranslationKey.tradeUnionFormError500]: 'Something went wrong while creating the case. Please try again and contact us if the problem persists',
    [TranslationKey.tradeUnionFormError401]: 'You are not authorized to use this form',
    [TranslationKey.tradeUnionFormSuccessMessage]: 'Thank you, your case has been registered',
    [TranslationKey.tradeUnionFormMemberEmail]: `The member's email address`,
    [TranslationKey.tradeUnionFormMemberPhone]: `The member's mobile telephone number`,
    [TranslationKey.cgiAnotherDeviceStep1]: 'Open the {provider} app on your mobile device',
    [TranslationKey.cgiAnotherDeviceStep2]: 'Scan the QR code.',
    [TranslationKey.cgiAnotherDeviceStep3]: 'Authenticate yourself.',
    [TranslationKey.cgiBankIdSameDevice]: 'BankID (same device)',
    [TranslationKey.cgiBankIdOtherDevice]: 'BankID (other device)',
    [TranslationKey.cgiFrejaSameDevice]: 'Freja (same device)',
    [TranslationKey.cgiFrejaOtherDevice]: 'Freja (other device)',
    [TranslationKey.cgiErrorGeneric]: 'Something went wrong with the authentication. Please try again.',
    [TranslationKey.cgiMobileInstructions]: 'To authenticate, click the button below to open the {provider} app.',
    [TranslationKey.cgiAutostartButtonText]: 'Start the {provider} app',
    [TranslationKey.cgiTitle]: 'Authenticate yourself with the {provider} app',
    [TranslationKey.resumedMemberShipFormTitle]: 'Application for resumed membership',
    [TranslationKey.resumedMemberShipFormErrorMessage]: 'Unfortunately, we were unable to submit your application. Please try again. Contact us if the problem persists.',
    [TranslationKey.resumedMembershipFormDirectDebit]: 'Do you want to pay using direct debit?',
    [TranslationKey.resumedMemberShipFormSign]: 'Sign the application',
    [TranslationKey.resumedMemberShipFormBankInput]: 'Bank',
    [TranslationKey.resumedMemberShipFormClearingInput]: 'Clearing number',
    [TranslationKey.resumedMemberShipFormAccountInput]: 'Account number',
    [TranslationKey.resumedMemberShipFormDirectDebitConsent]: 'I accept the terms and conditions for direct debit',
    [TranslationKey.resumedMemberShipFormConsent]: 'I apply to rejoin Akademikernas a-kassa',
    [TranslationKey.resumedMemberShipFormConsentErrorMessage]: 'You need to accept this in order to re-apply for unemployment insurance',
    [TranslationKey.resumedMemberShipFormSubmit]: 'Submit application',
    [TranslationKey.resumedMemberShipFormCgiSignText]: 'I apply for membership in Akademikernas a-kassa.',
    [TranslationKey.powerOfAttorneyFormCgiSignText]: 'I apply for membership in Akademikernas a-kassa in direct connection to the termination of my current unemployment insurance. I therefore give Akademikernas a-kassa the power of attorney to request termination on my behalf.',
    [TranslationKey.powerOfAttorneyFormTitle]: 'Power of attorney for change',
    [TranslationKey.contactFormSubjectInput]: 'What do you need help with?',
    [TranslationKey.contactFormSubjectInputPlaceholder]: 'Select category...',
    [TranslationKey.contactFormTitle]: 'Send us an email',
    [TranslationKey.contactFormSocialSecurityNumberSubLabel]: 'We can help you faster if you provide your personnummer.',
    [TranslationKey.refundFormTitle]: 'Apply for a payment plan',
    [TranslationKey.refundFormMonthValidationMessage]: 'Please select a valid period',
    [TranslationKey.refundFormAmountValidationMessage]: 'Please enter an amount higher than 0 SEK',
    [TranslationKey.refundFormAmountPlaceholder]: 'Enter in SEK',
    [TranslationKey.refundFormAmountLegend]: 'What total amount do you want to pay back?',
    [TranslationKey.refundFormPaymentPlanLegend]: 'How do you want to divide the payments?',
    [TranslationKey.refundFormPaymentPlanSublabel]: 'The selected total amount affects the number of months you can choose between',
    [TranslationKey.refundFormPaymentPlanPlaceholder]: 'Select number of months',
    [TranslationKey.refundFormSuggestionsLabel]: 'Suggestions',
    [TranslationKey.refundFormSuggestionsSublabel]: 'Do you have any other suggestions for the number of months or a specific amount per month? Give us your proposal here',
    [TranslationKey.refundFormReferenceSublabel]: 'Enter one of the following: your personnummer, the invoice OCR number or the refund reference number',
    [TranslationKey.refundFormOtherSuggestions]: 'Other suggestions',
  },
  'sv-SE': {
    [TranslationKey.uiButtonNext]: 'Gå vidare',
    [TranslationKey.uiButtonBack]: 'Tillbaka',
    [TranslationKey.uiButtonGoBack]: 'Gå tillbaka',
    [TranslationKey.uiStartTitle]: 'Vad bra att du vill bli medlem i Akademikernas a-kassa',
    [TranslationKey.uiBeginLegimitize]: 'Legitimera dig för att börja',
    [TranslationKey.uiSpecify]: 'Ange',
    [TranslationKey.uiSpecifyCountry]: 'Ange land',
    [TranslationKey.uiPersonalIdNumber]: 'Personnummer',
    [TranslationKey.uiBankIdTitle]: 'Öppna BankID',
    [TranslationKey.uiSubmit]: 'Skicka in ärende',
    [TranslationKey.uiEdit]: 'Redigera',
    [TranslationKey.uiName]: 'Medlemmens namn',
    [TranslationKey.uiCancel]: 'Avbryt',
    [TranslationKey.uiLogin]: 'Starta legitimering',
    [TranslationKey.uiTryAgain]: 'Försök igen',
    [TranslationKey.uiClickHere]: 'Klicka här',
    [TranslationKey.uiErrorTitle]: 'Något gick fel',
    [TranslationKey.uiPersonalInformation]: 'Personuppgifter',
    [TranslationKey.uiPowerOfAttorney]: 'Fullmakt',
    [TranslationKey.uiMonths]: 'Månader',
    [TranslationKey.errorRequired]: 'Fältet kan inte lämnas tomt',
    [TranslationKey.errorInvalidEmail]: 'Vänligen ange en korrekt emailadress',
    [TranslationKey.errorOneOfPayments]: 'Du måste välja ett betalningsalternativ',
    [TranslationKey.errorChooseAssociation]: 'Vänligen välj en förening att betala via',
    [TranslationKey.errorFillInRequiredFields]: 'Vänligen fyll i samtliga nödvändiga fält',
    [TranslationKey.errorInvalidPersonalID]: 'Vänligen fyll i ett giltigt personnummer',
    [TranslationKey.errorExactNumberOfNumbers]: 'Får endast vara {length} siffror',
    [TranslationKey.errorTooLong]: `Får inte vara längre än {length} karaktärer`,
    [TranslationKey.errorTooShort]: `Får inte vara kortare än {length} karaktärer`,
    [TranslationKey.errorSubmissionError]:
      'Något gick fel när vi försökte skicka in din ansökan. Vänligen kolla att din information är korrekt och försök igen.',
    [TranslationKey.errorInvalidBankAccount]:
      'Det verkar inte som att ditt kontonummer stämmer. Har du skrivit in både clearing- och kontonumret?',
    [TranslationKey.errorConsentRequired]: 'Du måste godkänna villkoren för att kunna skicka in',
    [TranslationKey.errorOneOf]: 'Du måste välja ett alternativ',
    [TranslationKey.errorBankIDTimeout]: 'Inloggningen avbröts på grund av inaktivitet',
    [TranslationKey.errorAcceptCondtions]: 'Du måste acceptera villkoren',
    [TranslationKey.errorMismatch]: 'Se till att värdet matchar {otherField}-fältet',
    [TranslationKey.formFirstName]: 'Förnamn',
    [TranslationKey.formFamilyName]: 'Efternamn',
    [TranslationKey.formName]: 'Namn',
    [TranslationKey.formFullName]: 'För- och efternamn',
    [TranslationKey.formPersonalIdentityNumber]: 'Personnummer',
    [TranslationKey.formStreetName]: 'Gatuadress',
    [TranslationKey.formPostalCode]: 'Postnummer',
    [TranslationKey.formCity]: 'Postort',
    [TranslationKey.formCountry]: 'Land',
    [TranslationKey.formEmailAddress]: 'E-postadress',
    [TranslationKey.formPhoneNumber]: 'Mobilnummer',
    [TranslationKey.formFullAddress]: 'Gatuadress, postnummer och ort',
    [TranslationKey.formStreetAddress]: 'Gatuadress',
    [TranslationKey.formSelectAuthenticationOption]: 'Välj autentiseringsmetod',
    [TranslationKey.formRepeat]: 'Upprepa {fieldName}',
    [TranslationKey.formSocialSecurityNumber]: 'Personnummer',
    [TranslationKey.formMessage]: 'Meddelande',
    [TranslationKey.formAttachFile]: 'Bifoga fil',
    [TranslationKey.formTotalAmount]: 'Totalbelopp',
    [TranslationKey.formNumberOfMonths]: 'Antal månader',
    [TranslationKey.formReference]: 'Referens',
    [TranslationKey.submissionErrorBadRequest]: 'Informationen du angav i formuläret är inkorrekt. Vänligen kontrollera den och försök igen.',
    [TranslationKey.tradeUnionFormPaymentType1]: 'Betala direkt till a-kassan (direktanslutning)',
    [TranslationKey.tradeUnionFormPaymentType2]: 'Betala till förbund (ta över fakturering)',
    [TranslationKey.tradeUnionFormDate]: 'Förändringen ska ske från och med',
    [TranslationKey.tradeUnionFormReason]: 'Anledning',
    [TranslationKey.tradeUnionFormPaymentType]: 'Betalningsalternativ',
    [TranslationKey.tradeUnionFormSelectPaymentType]: 'Välj betalningsalternativ',
    [TranslationKey.tradeUnionFormHeading]: 'Ändring av betalsätt',
    [TranslationKey.tradeUnionFormError400]: 'Informationen du har angett är inkorrekt. Vänligen kontrollera fälten och försök igen',
    [TranslationKey.tradeUnionFormError404]: 'Det finns ingen medlem med det angivna personnumret',
    [TranslationKey.tradeUnionFormError500]: 'Något gick fel när ärendet skulle skapas. Vänligen försök igen och kontakta oss ifall problemet kvarstår',
    [TranslationKey.tradeUnionFormError401]: 'Du har inte behörighet att använda detta formulär',
    [TranslationKey.tradeUnionFormSuccessMessage]: 'Tack, ditt ärende har registrerats',
    [TranslationKey.tradeUnionFormMemberEmail]: 'Medlemmens e-postadress',
    [TranslationKey.tradeUnionFormMemberPhone]: 'Medlemmens mobilnummer',
    [TranslationKey.cgiAnotherDeviceStep1]: 'Öppna {provider}-appen i mobilen.',
    [TranslationKey.cgiAnotherDeviceStep2]: 'Scanna QR-koden.',
    [TranslationKey.cgiAnotherDeviceStep3]: 'Legitimera dig själv.',
    [TranslationKey.cgiBankIdSameDevice]: 'BankID (samma enhet)',
    [TranslationKey.cgiBankIdOtherDevice]: 'BankID (annan enhet)',
    [TranslationKey.cgiFrejaSameDevice]: 'Freja (samma enhet)',
    [TranslationKey.cgiFrejaOtherDevice]: 'Freja (annan enhet)',
    [TranslationKey.cgiErrorGeneric]: 'Något gick fel med autentiseringen. Vänligen försök igen.',
    [TranslationKey.cgiMobileInstructions]: 'För att signera, klicka på knappen nedan för att öppna {provider}-appen.',
    [TranslationKey.cgiAutostartButtonText]: 'Starta {provider}-appen',
    [TranslationKey.cgiTitle]: 'Legitimera dig med {provider}-appen',
    [TranslationKey.resumedMemberShipFormTitle]: 'Ansökan om fortsatt medlemskap',
    [TranslationKey.resumedMemberShipFormErrorMessage]: 'Tyvärr gick det inte att skicka ansökan. Vänligen försök igen. Kontakta oss ifall problem kvarstår.',
    [TranslationKey.resumedMembershipFormDirectDebit]: 'Vill du betala med autogiro?',
    [TranslationKey.resumedMemberShipFormSign]: 'Signera ansökan',
    [TranslationKey.resumedMemberShipFormBankInput]: 'Bank',
    [TranslationKey.resumedMemberShipFormClearingInput]: 'Clearingnummer',
    [TranslationKey.resumedMemberShipFormAccountInput]: 'Kontonummer',
    [TranslationKey.resumedMemberShipFormDirectDebitConsent]: 'Jag godkänner villkoren för autogiro',
    [TranslationKey.resumedMemberShipFormConsent]: 'Jag ansöker om att gå med i Akademikernas a-kassa på nytt',
    [TranslationKey.resumedMemberShipFormConsentErrorMessage]: 'Du behöver godkänna detta för att kunna arbetslöshetsförsäkra dig på nytt',
    [TranslationKey.resumedMemberShipFormSubmit]: 'Skicka in ansökan',
    [TranslationKey.resumedMemberShipFormCgiSignText]: 'Jag ansöker om medlemskap i Akademikernas a-kassa.',
    [TranslationKey.powerOfAttorneyFormCgiSignText]: 'Jag ansöker om medlemskap i Akademikernas a-kassa i direkt anslutning till att mitt medlemskap i nuvarande a-kassa upphör. Jag ger därför Akademikernas a-kassa fullmakt att för min räkning begära utträde.',
    [TranslationKey.powerOfAttorneyFormTitle]: 'Fullmakt för byte',
    [TranslationKey.contactFormSubjectInput]: 'Vad vill du ha hjälp med?',
    [TranslationKey.contactFormSubjectInputPlaceholder]: 'Välj kategori...',
    [TranslationKey.contactFormTitle]: 'Mejla oss',
    [TranslationKey.contactFormSocialSecurityNumberSubLabel]: 'Vi kan hjälpa dig snabbare om du anger ditt personnummer.',
    [TranslationKey.refundFormTitle]: 'Ansök om avbetalningsplan',
    [TranslationKey.refundFormMonthValidationMessage]: 'Vänligen välj en giltig period',
    [TranslationKey.refundFormAmountValidationMessage]: 'Vänligen ange ett belopp högre än 0 kr',
    [TranslationKey.refundFormAmountPlaceholder]: 'Ange i kr',
    [TranslationKey.refundFormAmountLegend]: 'Vilket totalbelopp ska du betala tillbaka?',
    [TranslationKey.refundFormPaymentPlanLegend]: 'Hur önskar du dela upp betalningarna?',
    [TranslationKey.refundFormPaymentPlanSublabel]: 'Det valda totalbeloppet påverkar antalet månader du kan välja mellan',
    [TranslationKey.refundFormPaymentPlanPlaceholder]: 'Välj antal månader',
    [TranslationKey.refundFormSuggestionsLabel]: 'Önskemål',
    [TranslationKey.refundFormSuggestionsSublabel]: 'Har du något annat önskemål om antal månader eller ett visst belopp per månad? Ge oss ditt förslag här',
    [TranslationKey.refundFormReferenceSublabel]: 'Ange något av följande: ditt personnummer, fakturans OCR-nummer eller återkravets referensnummer',
    [TranslationKey.refundFormOtherSuggestions]: 'Annat önskemål',
  },
};
